import moment from "moment";
import NavBarTop from "@/components/shared/NavBarTop";
import { getSiteDailyWorkRecordsApi, postSiteDailyWorkRecordApi, deleteSiteDailyWorkRecordApi } from "@/api/SiteDailyWorkRecordApi";
import { generateSiteDailyWorkRecordExcel } from "@/api/SiteApi";
import { configDatePick } from "@/services/GlobalServices";
import DiaryListConstants from "@/store/constants/diaryListRecords";
import { mapWorkRecord } from "./workRecordMapper";
import BackToListLink from "@/components/shared/BackToListLink";

export default {
  name: "SiteDailyWorkRecord",
  components: {
    NavBarTop,
    BackToListLink
  },
  data() {
    return {
      selectedSiteId: null,
      workDate: moment().format("YYYY-MM-DD"),
      workerType: "EMPLOYEE",
      workerCount: 0,
      totalHours: 0,
      searchStartDate: moment().subtract(3, 'months').format("YYYY-MM-DD"),
      searchEndDate: moment().add(3, 'months').format("YYYY-MM-DD"),
      records: [],
      loading: false,
      datePickerOptions: configDatePick("YYYY-MM-DD", false),
      workerTypes: [
        { value: "EMPLOYEE", text: "正社員" },
        { value: "NON_REGULAR_EMPLOYEE", text: "雇員" },
        { value: "JV_EMPLOYEE", text: "共同企業体職員" },
        { value: "CONTRACTOR", text: "契約社員" }
      ],
      tableFields: [
        { key: "workDate", label: "作業実施日", sortable: true },
        { key: "workerType", label: "作業者種別", sortable: true },
        { key: "contractCompanyName", label: "契約会社名", sortable: true },
        { key: "workerCount", label: "作業者数", sortable: true },
        { key: "totalHours", label: "総作業時間", sortable: true },
        { key: "actions", label: "操作", sortable: false }
      ]
    };
  },
  computed: {
    sites() {
      return this.$store.getters[DiaryListConstants.GETTERS.getSites];
    },
    currentUser() {
      return this.$store.getters[DiaryListConstants.GETTERS.getMe];
    },
    isContractUser() {
      console.log('currentUser:', this.currentUser);
      console.log('contractor_token:', localStorage.getItem('contractor_token'));
      
      // 契約社員トークンが存在する場合は契約社員として判定
      const hasContractorToken = !!localStorage.getItem('contractor_token');
      
      // currentUserが取得できている場合はそれも確認
      const isContractFromUser = this.currentUser && this.currentUser.type === 'contract';
      
      const isContract = hasContractorToken || isContractFromUser;
      console.log('isContractUser result:', isContract);
      
      return isContract;
    },
    availableWorkerTypes() {
      if (this.isContractUser) {
        return this.workerTypes.filter(type => type.value === 'CONTRACTOR');
      }
      return this.workerTypes.filter(type => type.value !== 'CONTRACTOR');
    },
    canSave() {
      return this.selectedSiteId &&
             this.workDate &&
             this.workerType &&
             this.workerCount > 0 &&
             this.totalHours > 0;
    }
  },
  watch: {
    currentUser(newUser) {
      console.log('currentUser changed:', newUser);
      if (this.isContractUser) {
        this.workerType = "CONTRACTOR";
        console.log('Contract user detected in watcher, setting workerType to CONTRACTOR');
      }
    },
    isContractUser(isContract) {
      console.log('isContractUser changed:', isContract);
      if (isContract) {
        this.workerType = "CONTRACTOR";
        console.log('Contract user detected via isContractUser watcher, setting workerType to CONTRACTOR');
      }
    }
  },
  created() {
    this.initializeData();
  },
  
  mounted() {
    // データが取得された後に契約社員の判定を行う
    this.$nextTick(() => {
      if (this.isContractUser) {
        this.workerType = "CONTRACTOR";
        console.log('Contract user detected, setting workerType to CONTRACTOR');
      }
    });
    
    const siteId = this.$route.query.siteId;
    if (siteId) {
      this.selectedSiteId = siteId;
      this.loadRecords();
    }
  },
  methods: {
    async initializeData() {
      try {
        await this.$store.dispatch(DiaryListConstants.DISPATCH.getSiteRecords);
        await this.$store.dispatch(DiaryListConstants.DISPATCH.getMeRecord);
      } catch (error) {
        console.error('初期データの取得に失敗しました:', error);
      }
    },
    onSiteChange() {
      if (this.selectedSiteId) {
        this.loadRecords();
      }
    },
    onDateChange() {
      console.log('作業実施日が変更されました:', this.workDate);
    },
    async saveRecord() {
      if (!this.canSave) {
        this.$bvToast.toast('必要な項目を入力してください', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
        return;
      }

      try {
        const recordData = {
          siteId: this.selectedSiteId,
          workDate: this.workDate,
          workerType: this.workerType,
          workerCount: this.workerCount,
          totalHours: this.totalHours
        };

        await postSiteDailyWorkRecordApi(recordData);
        
        this.$bvToast.toast('作業記録を保存しました', {
          title: '成功',
          variant: 'success',
          solid: true
        });

        this.loadRecords();
      } catch (error) {
        console.error('作業記録の保存に失敗しました:', error);
        this.$bvToast.toast('作業記録の保存に失敗しました', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
      }
    },
    async loadRecords() {
      if (!this.selectedSiteId) return;

      this.loading = true;
      try {
        const params = {
          siteId: this.selectedSiteId,
          startDate: this.searchStartDate,
          endDate: this.searchEndDate,
          limit: 100,
          offset: 0
        };

        const response = await getSiteDailyWorkRecordsApi(params);
        this.records = (response.result || []).map(mapWorkRecord);
      } catch (error) {
        console.error('記録の取得に失敗しました:', error);
        this.$bvToast.toast('記録の取得に失敗しました', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.workerCount = 0;
      this.totalHours = 0;
      this.workDate = moment().format("YYYY-MM-DD");
    },
    formatDate(dateString) {
      return moment(dateString).format("YYYY年MM月DD日");
    },
    getWorkerTypeText(workerType) {
      const type = this.workerTypes.find(t => t.value === workerType);
      return type ? type.text : workerType;
    },
    async downloadExcel() {
      if (!this.selectedSiteId) {
        this.$bvToast.toast('現場を選択してください', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
        return;
      }

      try {
        this.loading = true;
        const response = await generateSiteDailyWorkRecordExcel(
          this.selectedSiteId,
          this.searchStartDate,
          this.searchEndDate
        );

        const blob = new Blob([Uint8Array.from(atob(response.data.excelData), c => c.charCodeAt(0))], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = response.data.fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.$bvToast.toast('Excelファイルをダウンロードしました', {
          title: '成功',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Excelダウンロードに失敗しました:', error);
        this.$bvToast.toast('Excelダウンロードに失敗しました', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loading = false;
      }
    },
    async deleteRecord(item) {
      if (item.hasContractCompany) return;

      const confirmed = await this.$bvModal.msgBoxConfirm('この記録を削除しますか？', {
        title: '削除確認',
        okVariant: 'danger',
        okTitle: '削除',
        cancelTitle: 'キャンセル',
        centered: true
      });

      if (!confirmed) return;

      try {
        await deleteSiteDailyWorkRecordApi(item.id);
        this.$bvToast.toast('記録を削除しました', {
          title: '成功',
          variant: 'success',
          solid: true
        });
        this.loadRecords();
      } catch (error) {
        console.error('記録の削除に失敗しました:', error);
        this.$bvToast.toast('記録の削除に失敗しました', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
};
